import styled from 'styled-components';
import { media } from '@app/styles/themes/constants';
import { BaseTypography } from '@app/components/common/BaseTypography/BaseTypography';
import { BaseDivider } from '@app/components/common/BaseDivider/BaseDivider';

export const Text = styled(BaseTypography.Text)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  font-size: 0.875rem;
  font-weight: 600;

  & > a {
    display: block;
    color: var(--text-main);
  }

  @media only screen and ${media.md} {
    font-size: 1rem;
  }
`;

export const MenuButton = styled.button`
  border: 0;
  background: none;
  cursor: pointer;
  padding: 0;
  font: inherit;
  color: var(--text-main);
`;

export const ItemsDivider = styled(BaseDivider)`
  margin: 0;
`;
